var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrap",attrs:{"id":"app"}},[_c('app-header'),_c('keep-alive',{attrs:{"include":['customerCarWash', 'managerCarWash', 'mineOrder', 'managerOrder']}},[_c('router-view',{staticClass:"app-content"})],1),_c('div',{staticClass:"color-#20BC7F color-#0778FF color-#FC3F3F color-#FE8F02"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }